import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { capitalizeEveryWord, joinClassnames } from '../utils';
import { ScrollArea, ScrollBar } from './ui/ScrollArea';
export const SourceResponseModal = (props: any) => {
  const { sourceResponseModAL, setSourceResponseModAL, list } = props;
  const [openDropdown, setOpenDropdown] = useState(Array(5).fill(false)); // Assuming you have 5 dropdowns

  const removeDuplicateCompany = (arr: any) => {
    const seen = new Set();
    return arr.filter((obj: any) => {
      const duplicate = seen.has(obj.CompanyName);
      seen.add(obj.CompanyName);
      return !duplicate;
    });
  };
  const listView = list?.dataSource === 'VIP Insights' ? removeDuplicateCompany(list?.data) : list?.data;

  const handleDropdown = (index: number) => {
    const newDropdowns = [...openDropdown];
    newDropdowns[index] = !newDropdowns[index];
    setOpenDropdown(newDropdowns);
  };

  console.log(list);

  return (
    <Transition.Root show={sourceResponseModAL} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={() => setSourceResponseModAL(false)}>
        {/* Opaque overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity" />
        </Transition.Child>

        {/* Modal panel */}
        <div className="fixed inset-0 z-10 ">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative flex w-4/5 max-h-[483px] pb-[72px] transform flex-col gap-8 bg-[#FFFFFF] py-[24px] pl-[24px] font-graphik text-white transition-all lg:w-2/3 border-t-[4px] border-purple-600">
                <button
                  onClick={() => setSourceResponseModAL(false)}
                  className="flex items-center justify-center self-end text-black w-6 min-w-[24px] h-6 min-h-[24px] rounded-full bg-white hover:bg-opacity-70 focus:outline-none"
                >
                  <span className="material-symbols-outlined material-symbols-outlined-bold text-[20px] pr-[24px]">
                    close
                  </span>
                </button>
                <div className="transcript-data-wrapper flex flex-col gap-5 h-[calc(100%-56px)] overflow-auto">
                  <div className="flex justify-between items-start gap-6 h-fit">
                    <div className="flex flex-col gap-2">
                      <span className="text-[#000] text-[20px] font-semibold leading-[28px] tracking-[-0.36px] text-left">
                        {list?.dataSource == 'VIP Insights' ? 'Vip Insights Platform' : list?.dataSource}
                      </span>
                      <span className="text-[#000] text-left text-[14px] leading-[24px] pr-8">
                        {list?.dataSource == 'Thought Leadership' || list?.dataSource == 'VIP Insights'
                          ? ''
                          : 'Snippet used to inform the AI response'}
                      </span>
                    </div>
                  </div>
                  <div className="Scrollbar">
                    {listView?.map((value: any, index: any) => (
                      <div
                        key={index}
                        className="transcript-content flex flex-col border-purple-600 border-[1px] mb-3 mr-[24px]"
                      >
                        <div className="relative text-[#000] border-t-6 border-b-6 border-l-4 border-purple-600 px-[16px] py-[22px]">
                          <h3 className="flex items-center justify-between text-[13px] font-semibold leading-[27px] tracking-[-0.36px] text-left">
                            {list?.dataSource == 'VIP Insights' ? (
                              ''
                            ) : (
                              <>
                                <p onClick={() => handleDropdown(index)}>{value?.eventTitle}</p>
                                <img
                                  className={joinClassnames(
                                    openDropdown[index] ? 'rotate-180' : 'rotate-0',
                                    ' w-[2%] cursor-pointer'
                                  )}
                                  onClick={() => handleDropdown(index)}
                                  alt="down"
                                  src="/icons/Down.svg"
                                />
                              </>
                            )}
                          </h3>
                          {list?.dataSource == 'VIP Insights' ? (
                            <a className="text-[16px]" href={value?.Url} target="_blank" rel="noreferrer">
                              {value?.speakerName?.split('\n').map((line: any, index: any) => (
                                <div key={index}>
                                  {line}
                                  {index !== value?.speakerName?.split('\n').length - 1 && <br />}
                                </div>
                              ))}
                              {value?.CompanyName}
                            </a>
                          ) : (
                            <p className="text-[12px]">
                              {value?.speakerName?.split('\n').map((line: any, index: any) => (
                                <div key={index}>
                                  {line}
                                  {index !== value?.speakerName?.split('\n').length - 1 && <br />}
                                </div>
                              ))}
                              {value?.CompanyName}
                            </p>
                          )}
                          {openDropdown[index] && (
                            <>
                              <p className="text-[12px] mt-4">
                                {value?.content?.split('\n').map((line: any, index: any) => (
                                  <div key={index}>
                                    {line}
                                    {index !== value?.content?.split('\n').length - 1 && <br />}
                                  </div>
                                ))}
                              </p>
                              <a className="text-xs text-blue-500" href={value?.Url} target="_blank" rel="noreferrer">
                                {list?.dataSource == 'VIP Insights' ? '' : value?.Url}
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div>
                    <ScrollArea className="w-full">
                      <ScrollBar orientation="vertical" />
                      {/* <p className="text-[#000] text-left text-[14px] leading-[24px] pr-8">{currentTranscript}</p> */}
                    </ScrollArea>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
